import { PostgrestError } from "@supabase/supabase-js";
import { Notification } from "providers/NotifierProvider";
import { supabase } from "supabase/client";
import { Database } from "supabase/types";
import logSentryError from "utils/logSentryError";

type DbEventApps = Database["public"]["Tables"]["event_apps"];
export type EventAppsRow = DbEventApps["Row"];
export type EventAppsInsert = DbEventApps["Insert"];
export type EventAppsUpdate = DbEventApps["Update"];

class EventAppsApi {
  showNotification?: (notification: Notification) => void;

  constructor(showNotification?: (notification: Notification) => void) {
    this.showNotification = showNotification;
  }

  async getActiveApps(
    eventId: number,
    groupId: number
  ): Promise<{
    data: GetActiveAppsRes | null;
    error: PostgrestError | null;
  }> {
    const { data, error } = await supabase
      .from("event_apps")
      .select("active_apps")
      .eq("event_id", eventId)
      .eq("group_id", groupId)
      .single();

    if (error) {
      if (this.showNotification) {
        this.showNotification({
          message: "Unable to get active apps.",
          severity: "error",
        });
      }

      logSentryError(error, "EVENT_APPS_API: getActiveApps");
      return { data: null, error };
    }

    return { data, error: null };
  }
}

export default EventAppsApi;

export interface GetActiveAppsRes {
  active_apps: EventAppsRow["active_apps"];
}
